import { useMutation } from 'react-query'

import { updateRecurringInvoiceDraft } from '@features/recurringInvoices/query-api'

export const useUpdateRecurringInvoiceDraft = () => {
  const { mutate, isLoading: isProcessing } = useMutation(updateRecurringInvoiceDraft)

  return { updateRecurringInvoiceDraft: mutate, isProcessing }
}
